import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, model, output, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { KuiModule } from 'app/key-ui';
import { debounceTime, Subject } from 'rxjs';

@Component({
    selector: 'key-search',
    standalone: true,
    imports: [
        KuiModule,
        CommonModule,
        FormsModule
    ],
    host: {
        'class': 'input-group search'
    },
    templateUrl: './search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements AfterViewInit {

    private textbox = viewChild<ElementRef>('textbox');

    searchValue = model<string>();

    placeholder = input.required<string>();
    autoFocus = input<boolean>(false);
    debounceTime = input<number>(500);
    disabled = input<boolean>(false);

    submitSearch = output<string>();
    clear = output();

    private debounce = new Subject<string>();

    constructor() {
        this.debounce.pipe(
            takeUntilDestroyed(),
            debounceTime(this.debounceTime()),
        ).subscribe(res => {
            this.submitSearch.emit(res);
        });
    }

    ngAfterViewInit(): void {
        if (this.autoFocus() && this.textbox() && !this.disabled()) {
            setTimeout(() => {
                this.textbox().nativeElement.focus();
            }, 100);
        }
    }

    debounceSearch(value: string) {
        this.debounce.next(value);
    }
}
